var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.launchFullScreen()}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"fullicon",attrs:{"title":"На весь экран"}},[_c('i',{staticClass:"cni cni-focus"})])
}]

export { render, staticRenderFns }